import {cva} from 'class-variance-authority'

/**
 * Shared size/color variants for icons. Used by both `Icon` (the `name`-based lookup
 * component) and `createIcon` (the wrapper applied to each generated icon component so
 * it carries its own size/color/accessibility handling when imported and used directly,
 * e.g. `<ArrowBackIcon size="large" color="error" />`).
 *
 * Lives in its own module — not in `Icon.tsx` — so `create-icon.tsx` can import it
 * without a circular dependency (`Icon.tsx` → `__generated/icon-map.ts` → generated
 * icon files → `create-icon.tsx`).
 */
export const iconVariants = cva(
  'flex shrink-0 items-center justify-center leading-none transition-[color]',
  {
    variants: {
      size: {
        'extra-small': 'text-xs', // xs
        small: 'text-base', // base
        medium: 'text-xl', // xl
        large: 'text-2xl', // 2xl
        'extra-large': 'text-[28px]', // 28px
      },
      color: {
        current: 'text-current',
        text: 'text-text',
        black: 'text-black',
        white: 'text-white',
        default: 'text-icon',
        hover: 'text-icon-hover',
        pressed: 'text-icon-pressed',
        selected: 'text-icon-selected',
        disabled: 'text-icon-disabled',
        secondary: 'text-icon-secondary',
        tertiary: 'text-icon-tertiary',
        inverse: 'text-icon-inverse',
        'inverse-secondary': 'text-icon-inverse-secondary',
        info: 'text-icon-info',
        error: 'text-icon-error',
        success: 'text-icon-success',
        warning: 'text-icon-warning',
      },
    },
    defaultVariants: {
      size: 'medium',
      color: 'default',
    },
  },
)
